module.exports = __webpack_public_path__ + "img/hexagon.1daae5bf.svg";